import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import '../../../../assets/scss/components/createNewUser.scss';
import axios from 'axios';
import store from '../../../../redux';
import UserForm from './UserForm';
import { useDispatch } from 'react-redux';
import { Spinner } from 'reactstrap';

const EditUserForm = () => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const [user, setUser] = useState({});
  const [userLoading, setUserLoading] = useState(false);

  const userToken = store.getState().auth.login.data.access_token;

  const token = 'Bearer ' + userToken;
  const getSingleUser = async (data) => {
    setUserLoading(true);
    // const response = await axios.post('http://20.102.45.175:8300/api/get_user/', data, {
    const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/get_user/`, data, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: token
      }
    });
    if (response.status === 200) {
      setUser(response.data.data[0]);
    }
    setUserLoading(false);
  };

  useEffect(() => {
    if (id) {
      getSingleUser({
        target: 'select',
        email: atob(id)
      });
    }
  }, [dispatch, id]);

  return (
    <div className="p-3 bg-white shadow rounded border border-light create-new-user">
      <h1 className="text-center text-primary font-weight-bold">
        Edit the user with the name ({' '}
        {userLoading ? (
          <Spinner size="sm" color="primary" />
        ) : (
          <span className="text-secondary font-weight-normal text-capitalize">{user.username}</span>
        )}{' '}
        )
      </h1>
      <UserForm
        user={user}
        userLoading={userLoading}
        //  handleUser={handleUpdateUser}
      />
    </div>
  );
};

export default EditUserForm;
